import React from 'react';
import { theme, createButtonStyle } from '../../theme';
import "./Button.css";

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  onClick,
  type = 'button',
  className = '',
  style = {},
  ...props
}) => {
  const buttonStyle = {
    ...createButtonStyle(variant, size),
    ...style,
    opacity: disabled || loading ? 0.6 : 1,
    cursor: disabled || loading ? 'not-allowed' : 'pointer',
    position: 'relative'
  };

  const handleClick = (e) => {
    if (disabled || loading) return;
    onClick && onClick(e);
  };

  return (
    <button
      type={type}
      className={`themed-button ${className}`}
      style={buttonStyle}
      onClick={handleClick}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <div
          style={{
            marginRight: theme.spacing[2],
            width: '16px',
            height: '16px',
            border: '2px solid transparent',
            borderTop: `2px solid ${variant === 'secondary' ? theme.colors.gray[600] : 'currentColor'}`,
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}
        />
      )}
      {children}
    </button>
  );
};

export { Button };
export default Button;
  